export const secondsToTimeString = (value: number): string => {
  const seconds = value % 60;
  const minutes = Math.floor(value / 60);
  return (
    (minutes < 10 ? '0' + minutes : minutes) +
    ':' +
    (seconds < 10 ? '0' + seconds : seconds)
  );
};
